export const normalizeFileName = (
  filename: string,
  { skipCodeFileException = false }: { skipCodeFileException?: boolean } = {}
): string => {
  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex === -1) {
    throw new Error('File without extension');
  }

  const name = filename.slice(0, lastDotIndex);
  const ext = filename.slice(lastDotIndex + 1);

  const lowerExt = ext.toLowerCase();
  const extWithDot = `.${lowerExt}`;

  if (
    !skipCodeFileException &&
    ['.py', '.ts', '.tsx', '.js', '.jsx', '.json', '.csv'].includes(extWithDot)
  ) {
    return filename;
  }

  const safeName = name.replace(/[^a-zA-Z0-9]+/g, '_');
  const cleanedName = safeName.replace(/_+/g, '_').replace(/^_+|_+$/g, '');

  return `${cleanedName}${extWithDot}`;
};
